module.exports = __webpack_public_path__ + "static/media/p44-logo-full-color.760ef2b7.png";